import './skillhubBootstrap'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import '@repo/common-utils/css/index.css'
import '@repo/common-utils/css/reset.css'
import installVant from '@repo/vant4'
import { registerLogout, registerToast } from '@repo/http'
import logout from '@repo/common-components/business-components/logout/index'
import '@repo/common-utils/init'
import i18n from '@repo/i18n/common'
import type { ToastOptions } from 'vant'
import { showToast } from 'vant'
import { initLandingLocale } from './composables/useLandingLocale'
import { initAnalytics } from './adapters/analytics'
import App from './App.vue'
import router from './router'
import './styles.css'
import './styles/skillhub-shell.css'
import './styles/app-scrollbar.css'

initLandingLocale()
registerLogout(logout)
registerToast((payload: string | ToastOptions) => showToast(payload))
const app = createApp(App)
app.use(createPinia())
app.use(router)
app.use(i18n)
app.use(installVant)
initAnalytics(app)
router.isReady().then(() => {
  app.mount('#app')
})
